import React from 'react';
import { motion } from 'framer-motion';
const newsItems = ['Admission Open 2026 – Apply Now!', 'Annual Exam Schedule Published', 'Science Fair Winners Announced', 'Inter-School Debate Competition – 1st Place', 'New Computer Lab Inaugurated', 'Parent-Teacher Meeting – March 15', 'Sports Day Registration Open'];
export function NewsTicker() {
  return <div className="bg-gold text-white py-3 overflow-hidden" data-id="element-229">
      <div className="flex items-center" data-id="element-230">
        <div className="bg-primary px-6 py-1 font-semibold text-sm whitespace-nowrap" data-id="element-231">
          BREAKING NEWS
        </div>
        <div className="flex-1 overflow-hidden" data-id="element-232">
          <motion.div animate={{
          x: [0, -2000]
        }} transition={{
          duration: 30,
          repeat: Infinity,
          ease: 'linear'
        }} className="flex gap-12 pl-8" data-id="element-233">
            {[...newsItems, ...newsItems].map((item, index) => <span key={index} className="text-sm font-medium whitespace-nowrap" data-id="element-234">
                • {item}
              </span>)}
          </motion.div>
        </div>
      </div>
    </div>;
}